export default "__VITE_ASSET__BRY5su7m__"